export default __webpack_public_path__ + "static/slide2-b2e9363573c9764f8aaaf073c9823556.svg";